import { useTranslation } from 'react-i18next';
import type { PersonRef } from '@apis/reports';
import { CardIcon } from '@components/Pages/AnalyticsPage/CardIcon';
import { PersonnelRow } from './PersonnelRow';
import styles from './PersonnelSection.module.css';

interface IPersonnelSectionProps {
  personnel: PersonRef[];
  /** Stop-level arrival/departure range, used as a fallback when a row's
   * per-tag `workPeriods` is empty (degenerate / snapshot data missing).
   * Optional — Incident Report doesn't render per-tag times. */
  fallbackTimeText?: string;
  /** i18n key for the empty-state copy. Defaults to the Daily Route key;
   * Incident Report passes its own namespace. */
  emptyKey?: string;
}

export function PersonnelSection({
  personnel,
  fallbackTimeText = '',
  emptyKey = 'reports.dailyRoute.empty.personnel',
}: IPersonnelSectionProps) {
  const { t } = useTranslation();

  if (personnel.length === 0) {
    return (
      <div role="status" className={styles.empty}>
        <CardIcon name="user-with-cross" size={16} />
        <span>{t(emptyKey)}</span>
      </div>
    );
  }

  return (
    <ul className={styles.list}>
      {personnel.map((p) => (
        <PersonnelRow key={p.tagId} person={p} fallbackTimeText={fallbackTimeText} />
      ))}
    </ul>
  );
}
